//import axios from 'axios'
//import {API_BASE} from '../config'

export default class {

    constructor() {
        // this.apiToken = '$2y$10$0JXSvkSvP1hPKTheUBvQcewPYjl2Q0wZmhMuCdPhNJPhqFZ.stKo2';
        // this.market_app_name = "lookbookgallery"; 
        // this.app_url = "https://lookbookgallery.com";
        // this.app_name = "Lookbook Gallery";
        // this.sp_url = "https://wspk.herokuapp.com";
        // this.siteUrl = 'http://share.sellpoints.com.ng/';

        //this.apiToken = '$2y$10$iTLlb8m0C02omq0.rLlzI.TpbBzp0zTh7XfJTiElthAinbFUsHNa2'; //afap
        this.apiToken = '$2y$10$D5j6osoFJ3p3XCrnze4BOURXQ2kr0NEYIoe5fzidg0KXAFDxTcGy';
        this.market_app_name = "eshop"; 
        this.market_app_temp_co_share = 3; //catalog
        this.market_app_default_plan = 697; //eshop-defalut 
        this.app_url =  "https://sellpoints.com.ng";//"http://localhost:4042/"; //"https://sellpoints.com.ng";
        this.app_name = "Msail";
        this.app_default_business_category = 4; ///food and
        this.sp_url = "https://sp.afiahub.com";
        this.siteUrl = 'http://share.sellpoints.com.ng/';

        this.video_exts = ['mp4','mp3'];
        // this.general_banner_image = "/static/assets/images/banner-general.jpg";
        this.general_banner_image = "";
        this.timeout_msg_wait_period = 8000;
        this.upload_wait_period = 60000; //40sec 
        this.max_media_upload = "7MB"; //40sec 
        this.app_default_color = "#ff0066";
        //heroku
        // this.baseURL = 'https://spap.herokuapp.com/';
        // this.baseURL = 'https://spattle.afiahub.com/api/';
       // this.baseURL = 'https://work.log4.webnigeria.ng/api/';
        //this.baseURL = 'http://localhost/spattle/api/';
        // this.baseURL = 'https://smp.afiahub.com/api/';
        this.baseURL = 'https://msail.afiahub.com/api/';
        //cloud files
        this.imageSellpointsURL = '';
        this.imageProductsURL = '';
        this.imageUsersURL = '';

        //ldbs
        this.udb_name = "udbase";
        this.s2gdb_name = "shop2gedadbase";
        this.adr_db_name = "active_dynamic_request_db";
        this.current_s2g_activity_db_name = "activity_shop2gedadbase";
        this.store_db = [
            {db_id:9,db_name:"wishlistdbase",db_tag:"wishlist"},
            {db_id:10,db_name:"saveditemsdbase",db_tag:"saveditems"},
            {db_id:11,db_name:"savedshopsdbase",db_tag:"savedshops"},
        ];
        this.set_sellpoint_db = {tag:"sellpoint",db_name:"sellpoint"};
        //
        this.bdb_name = "businessbase";
        this.bbnksdb_name = "businessbankbase";
        this.bdlsdb_name = "businessdeliverylocationsbase";
        
        //error messages
        this.upload_media_error_msg = "Something went wrong uploading media, the format may not be supported or file size is too large, please try again";

        //app server settings
        this.app_proc_fee_calc = 0.13; //processing fees
        this.app_gigs_cash_out_proc_fee = 50;

        //payment-gateway-keys
        this.paystack_public_test = 'pk_test_1b578e2fe82975a4ec8a79e5d1a387c953fd2c3e';
        this.paystack_secret_test = '';
        this.paystack_public_live = '';
        this.paystack_secret_live = '';
        this.ravepay_public_test = 'FLWPUBK-8b636e40e721ae65285c678950808ef5-X';//devlot
        this.ravepay_secret_test = 'FLWSECK-fabdac3eae4762e5aadf5a27cef03d92-X';//devlot
        this.ravepay_public_live = '';
        this.ravepay_secret_live = '';
        //../payment-gateway-keys

        //paysets
        //--spcomms_holding_account_details
        this.spcomms_subaccount_id = "RS_52B66F9BA73E4B6FBAF82CF9E6530F25";
        this.spcomms_subaccount_bank_ravepay_id = "";
        this.spcomms_subaccount_bank_account_number = "";
        this.spcomms_subaccount_bank_account_name = "";

        //proxy
        this.proxyURL = "https://mediastream.afiahub.com/api/prx/";

        //3RD PARTIES INTEGRATIONS
        this.ravepay_test_path = "https://ravesandboxapi.flutterwave.com/";
        this.ravepay_live_path = "https://api.ravepay.co/";

        //for active usage on this file
        this.ravepay_call_path = this.ravepay_test_path; //switch btwn live n test
        this.ravepay_public_key = this.ravepay_public_test; //switch btwn live n test
        
    }

    
    //------data services
    //get states
    getStates(context, id) {
        return context.$http.get(this.baseURL+'states', {
            headers: {
               'Origin-Host': this.apiToken
            }
        })
    }

    //get cities
    getCities(context, id) {
        return context.$http.get(this.baseURL+'cities/'+id, {
            headers: {
               'Origin-Host': this.apiToken
            }
        })
    }

    getUtilities(context) {
        return context.$http.get(this.baseURL+'app/utilities/accounts', {
            headers: {
               'Origin-Host': this.apiToken
            }
        })
    }

    getFolders(context,folderFor,folderForId) {
        return context.$http.get(this.baseURL+'app/folders/'+folderFor+'/'+folderForId, {
            headers: {
               'Origin-Host': this.apiToken
            }
        })
    }

    getSetFolders(context,data) {
        return context.$http.post(this.baseURL+'app/folders', data, {
            headers: {
               'Origin-Host': this.apiToken
            }
        })
    }


    ///----business-market-app-services

    //validation
    //validate if Data exixit
    validateDataExist(context, data) {
        return context.$http.post(this.baseURL + 'validate/data/exist', data, {
             headers: {
                'Origin-Host': this.apiToken
            }
        });
    }

    //users

    // User registration
    regUser(context, data) {
        return context.$http.post(this.baseURL + 'users', data, {
             headers: {
                'Origin-Host': this.apiToken
            }
        });
    }
    // Loging in user
    loginUser(context, data) {
        return context.$http.post(this.baseURL + 'users/login', data, {
            headers: {
               'Origin-Host': this.apiToken
           }
       });
    }

    //searchForUser
    searchForUser(context, data) {
        return context.$http.post(this.baseURL + 'users/search', data, {
            headers: {
               'Origin-Host': this.apiToken
            }
       });
    }

    //
    activateUserToken(context, id) {
        return context.$http.get(this.baseURL + 'settings/activate/user/token/'+id,  {
            headers: {
                'Origin-Host': this.apiToken
            }
        });
    }

     //forgot password
     forgotPassword(context, data) {
        return context.$http.post(this.baseURL + 'settings/password/forgot', data, {
            headers: {
               'Origin-Host': this.apiToken
            }
       });
    }

    //verify reset password token
    verifyResetPasswordToken(context, id) {
        return context.$http.get(this.baseURL + 'settings/verify/reset/token/'+id,  {
            headers: {
                'Origin-Host': this.apiToken
            }
        });
    }

    //reset forgot password
    resetForgotPassword(context, data) {
        return context.$http.post(this.baseURL + 'settings/password/forgot/reset', data, {
            headers: {
                'Origin-Host': this.apiToken
            }
        });
    }

    //reset password
    resetPassword(context, data) {
        return context.$http.post(this.baseURL + 'settings/password/reset', data, {
            headers: {
                'Origin-Host': this.apiToken
            }
        });
    }

    //change email
    changeEmail(context, data) {
        return context.$http.post(this.baseURL + 'settings/email/reset', data, {
            headers: {
                'Origin-Host': this.apiToken
            }
        });
    }

    //session guard
    // sessionGuard(context, data) {
    //     return context.$http.post(this.baseURL + 'auth/sessions', data, {
    //         headers: {
    //             'Origin-Host': this.apiToken
    //         }
    //     });
    // }

    //session-guard-updated
    sessionGuard(context, data) {
        //before return check if passed
        //if not call session reauth
        //then return sessoin reauth data
        ///....
        //.....also once called provide or rewrite new session details if success
        //.....provide null or undefined defaults as session details 
        //..///this is to help headers and co pick accurate session details without preseting
        return context.$http.post(this.baseURL + 'auth/sessions', data, {
            headers: {
                'Origin-Host': this.apiToken
            }
        });
    }

    //session sync set
    sessionSyncSet(context, id) {
        return context.$http.get(this.baseURL + 'auth/sessions/sync/'+id,  {
            headers: {
                'Origin-Host': this.apiToken
            }
        });
    }

    //session sync
    sessionSync(context, data) {
        return context.$http.post(this.baseURL + 'auth/sessions/sync', data, {
            headers: {
                'Origin-Host': this.apiToken
            }
        });
    }

    //App Token
    //send app token to server
    sendAppToken(context, data) {
        return context.$http.post(this.baseURL + 'app/tokens', data, {
            headers: {
                'Origin-Host': this.apiToken
            }
        });
    }

    // Check User details
    checkUserDetails(context, data) {
        return context.$http.post(this.baseURL + 'users/checks', data, {
             headers: {
                'Origin-Host': this.apiToken
            }
        });
    }

    //edit user
    editProfileDetails(context, data) {
        return context.$http.put(this.baseURL + 'users', data, {
             headers: {
                'Origin-Host': this.apiToken
            }
        });
    }

    //--users

    //post subscriptions request
    makeAppSubscriptionOrder(context, data) {
        return context.$http.post(this.baseURL + 'app/businesses/subscription/orders', data, {
             headers: {
                'Origin-Host': this.apiToken
            }
        });
    
    }

    //update
    updateAppSubscriptionOrder(context, data) {
        return context.$http.post(this.baseURL + 'app/businesses/subscription/orders/updates', data, {
             headers: {
                'Origin-Host': this.apiToken
            }
        });
    }

    //businesses
    //can edit a sellpoint
    can_edit(context, data) {
        return context.$http.post(this.baseURL + 'auth/validate/ownership', data, {
             headers: {
                'Origin-Host': this.apiToken
            }
        });
    
    }
    //get business market
    getBusinessMarket(context, id) {
        return context.$http.get(this.baseURL + 'businesses/markets/'+id, {
            headers: {
               'Origin-Host': this.apiToken
            }
        });
    }
    //get delivery partners
    getAppDeliveryPartners(context, id) {
        return context.$http.get(this.baseURL+'app/deliverypartners', {
            headers: {
               'Origin-Host': this.apiToken
            }
        })
    }
    addDeliveryPartner(context, data) {
        return context.$http.post(this.baseURL+'businesses/deliverypartners',data, {
            headers: {
               'Origin-Host': this.apiToken
            }
        })
    }
    //get all users businesses
    getBusinesses(context, id) {
        return context.$http.get(this.baseURL+'businesses/'+id, {
            headers: {
               'Origin-Host': this.apiToken
            }
        })
    }

    //get all users businesses
    getAppBusinesses(context, id) {
        return context.$http.get(this.baseURL+'app/businesses/'+id, {
            headers: {
               'Origin-Host': this.apiToken
            }
        })
    }


    //get single business
    getBusinessByUserName(context, id) {
        return context.$http.get(this.baseURL+'businesses/usernames/'+id, {
            headers: {
               'Origin-Host': this.apiToken
            }
        })
    }
    
    //get single business
    getAppBusinessByUserName(context, id) {
        return context.$http.get(this.baseURL+'app/businesses/usernames/'+id, {
            headers: {
               'Origin-Host': this.apiToken
            }
        })
    }
    //get business products
    getBusinessProducts(context, id) {
        return context.$http.get(this.baseURL + 'products/businesses/'+id, {
            headers: {
               'Origin-Host': this.apiToken
            }
        });
    }

    getAppProducts(context, id, limit) {
        return context.$http.get(this.baseURL + 'products/markets/'+id, {
            headers: {
               'Origin-Host': this.apiToken
            }
        });
    }

    getAppBusinessProducts(context, id, limit) {
        return context.$http.get(this.baseURL + 'products/app/businesses/'+id+'/'+limit, {
            headers: {
               'Origin-Host': this.apiToken
            }
        });
    }

    addNewBusiness(context, data) {
        return context.$http.post(this.baseURL + 'businesses/new', data, {
             headers: {
               'Origin-Host': this.apiToken
            }
        });
    }

    addExistingBusiness(context, data) {
        return context.$http.post(this.baseURL + 'businesses/existing', data, {
             headers: {
               'Origin-Host': this.apiToken
            }
        });
    }

    //validateUserName
    validateBusinessUserName(context, data) {
        return context.$http.post(this.baseURL + 'businesses/validate/username', data, {
            headers: {
               'Origin-Host': this.apiToken
           }
       });
    }

    // getBusinessMarketUpgradeDetails(context, id) {
    //     return context.$http.get(this.baseURL + 'app/businesses/markets/upgrades/'+id, {
    //          headers: {
    //            'Origin-Host': this.apiToken
              
    //         }
    //     });
    // }

    setAppSubscriptionUpgradeDetails(context, data) {
        return context.$http.post(this.baseURL + 'app/subscription/upgrade/details', data, {
             headers: {
               'Origin-Host': this.apiToken
              
            }
        });
    }

    upgradeBusinessMarketSubscription(context, data) {
        return context.$http.post(this.baseURL + 'app/businesses/markets/upgrades', data, {
             headers: {
               'Origin-Host': this.apiToken
              
            }
        });
    }

    //get business categories
    getCategories(context) {
        return context.$http.get(this.baseURL+'categories', {
            headers: {
               'Origin-Host': this.apiToken
            }
        })
    }

    //get main categories in parent
    getMainCategories(context,id) {
        return context.$http.get(this.baseURL+'categories/main/'+id, {
            headers: {
                'Origin-Host': this.apiToken
            }
        })
    }

    //get sub  business categories
    getBusinessSubCategories(context,id) {
        return context.$http.get(this.baseURL+'categories/'+id, {
            headers: {
                'Origin-Host': this.apiToken
            }
        })
    }

    //get business categories
    getBusinessCategories(context,id) {
        return context.$http.get(this.baseURL+'businesses/categories/'+id, {
            headers: {
                'Origin-Host': this.apiToken
            }
        })
    }

    //following
    getFollowings(context, id) {
        return context.$http.get(this.baseURL + 'app/followings/'+id, {
            headers: {
               'Origin-Host': this.apiToken
            }
        });
    }

    addFollowing(context, data) {
        return context.$http.post(this.baseURL + 'followings', data, {
            headers: {
               'Origin-Host': this.apiToken
            }
        });
    }

    //market circle
    getAppMarketCircle(context, id) {
        return context.$http.get(this.baseURL + 'app/marketcircle/'+id, {
            headers: {
               'Origin-Host': this.apiToken
            }
        });
    }

    //subscriptions
    getAppSubscriptions(context, data) {
        return context.$http.post(this.baseURL + 'app/subscriptions', data, {
            headers: {
               'Origin-Host': this.apiToken
            }
        });
    }

    getAppSubscriptionOffers(context, data) {
        return context.$http.post(this.baseURL + 'app/subscriptions/offers', data, {
            headers: {
               'Origin-Host': this.apiToken
            }
        });
    }

    //posts
    getXPosts(context, type, id, offset, limit) {
        return context.$http.get(this.baseURL + 'app/xposts/points/'+type+'/'+id+'/'+offset+'/'+limit, {
            headers: {
               'Origin-Host': this.apiToken
            }
        });
    }

    getXPostsGroups(context, id, offset, limit) {
        return context.$http.get(this.baseURL + 'app/xposts/groups/'+id+'/'+offset+'/'+limit, {
            headers: {
               'Origin-Host': this.apiToken
            }
        });
    }

    addXPosts(context, data) {
        return context.$http.post(this.baseURL + 'xposts', data, {
             headers: {
               'Origin-Host': this.apiToken
              
            }
        });
    }

    //comlogs
    getComLogs(context,id) {
        return context.$http.get(this.baseURL + 'app/com/members/'+id, {
            headers: {
               'Origin-Host': this.apiToken
            }
        });
    }

    //create new group
    createNewGroup(context, data) {
        return context.$http.post(this.baseURL + 'groups', data, {
             headers: {
               'Origin-Host': this.apiToken
            }
        });
    }

    //create new group
    addMembersToGroups(context, data) {
        return context.$http.post(this.baseURL + 'groups/members', data, {
             headers: {
               'Origin-Host': this.apiToken
            }
        });
    }

    addNotifications(context, data) {
        return context.$http.post(this.baseURL + 'notifications', data, {
             headers: {
               'Origin-Host': this.apiToken
              
            }
        });
    }


    addGallery(context, data) {
        return context.$http.post(this.baseURL + 'posts/gallery', data, {
             headers: {
               'Origin-Host': this.apiToken
              
            }
        });
    }

    getPointGalleryPosts(context, id, offset, limit, posts_offset, posts_limit) {
        return context.$http.get(this.baseURL + 'posts/gallery/points/'+id+'/'+offset+'/'+limit+'/'+posts_offset+'/'+posts_limit, {
            headers: {
               'Origin-Host': this.apiToken
            }
        });
    }

    //get single gallery with name search
    getGallerySearch(context, id) {
        return context.$http.get(this.baseURL+'posts/gallery/url/'+id, {
            headers: {
               'Origin-Host': this.apiToken
            }
        })
    }

    //Edit business details
    editBusinessDetails(context, data) {
        return context.$http.put(this.baseURL + 'businesses/details', data, {
             headers: {
               'Origin-Host': this.apiToken
            }
        });
    }

    //businesses set processing fees options
    setShippingFeeStatus(context, data) {
        return context.$http.put(this.baseURL + 'businesses/setshippingfeestatus', data, {
             headers: {
               'Origin-Host': this.apiToken
            }
        });
    }

     //Add delivery_option to business
     addDeliveryOption(context, data) {
        return context.$http.post(this.baseURL + 'businesses/deliveryoptions', data, {
             headers: {
               'Origin-Host': this.apiToken
            }
        });
    }

    //Edit DeliveryOptions to business
    editDeliveryOption(context, data) {
        return context.$http.put(this.baseURL + 'businesses/deliveryoptions', data, {
             headers: {
               'Origin-Host': this.apiToken
            }
        });
    }

    //Delete DeliveryOptions to business
    deleteDeliveryOption(context, id, data) {
        return context.$http.put(this.baseURL + 'businesses/deliveryoptions/'+id, data, {
             headers: {
               'Origin-Host': this.apiToken
            }
        });
    }

    //business processing fee switch
    switchProcessingFeePay(context, data) {
        return context.$http.put(this.baseURL + 'businesses/processingfees', data, {
             headers: {
               'Origin-Host': this.apiToken
            }
        });
    }

    //business processing fee
    postBusinessProcessingFeeTransactions(context, data) {
        return context.$http.post(this.baseURL + 'businesses/processingfees/transactions', data, {
             headers: {
               'Origin-Host': this.apiToken
            }
        });
    }

    getBusinessProcessingFeesTransactions(context, id, offset, limit) {
        return context.$http.get(this.baseURL + 'businesses/processingfees/transactions/'+id+'/'+offset, {
            headers: {
               'Origin-Host': this.apiToken
            }
        });
    }

    //set business commissions
    setBusinessAgentCommissions(context, data) {
        return context.$http.put(this.baseURL + 'businesses/settings/commissions', data, {
             headers: {
               'Origin-Host': this.apiToken
            }
        });
    }

    getBusinessDiscountsCoupons(context, id) {
        return context.$http.get(this.baseURL + 'businesses/discountscoupons/'+id, {
            headers: {
               'Origin-Host': this.apiToken
            }
        });
    }

    //get business discounts and coupons
    getBusinessDiscountsAndCoupons(context, id) {
        return context.$http.get(this.baseURL + 'businesses/discounts/coupons/'+id, {
            headers: {
               'Origin-Host': this.apiToken
            }
        });
    }

    //set business discounts and coupons
    setDiscountsAndCoupons(context, data) {
        return context.$http.post(this.baseURL + 'businesses/discounts/coupons', data, {
             headers: {
               'Origin-Host': this.apiToken
            }
        });
    }

    //edit business discounts and coupons
    editDiscountsAndCoupons(context, data) {
        return context.$http.put(this.baseURL + 'businesses/discounts/coupons', data, {
             headers: {
               'Origin-Host': this.apiToken
            }
        });
    }

    //deactivate business discounts and coupons
    deactivateDiscountsAndCoupons(context, data) {
        return context.$http.put(this.baseURL + 'businesses/discounts/coupons/deactivate', data, {
             headers: {
               'Origin-Host': this.apiToken
            }
        });
    }
 

    //businesses

    //products

    //get sproduct images
    getProductImages(context, id) {
        return context.$http.get(this.baseURL+'products/images/'+id, {
            headers: {
               'Origin-Host': this.apiToken
            }
        })
    }
    deleteProductImage(context, id) {
        return context.$http.delete(this.baseURL+'products/images/'+id, {
            headers: {
               'Origin-Host': this.apiToken
            }
        })
    }
    //./products
    //uploads
    //Upload Image
    uploadDataPhoto(context, data) {
        return context.$http.post(this.baseURL + 'uploads', data, {
             headers: {
               'Origin-Host': this.apiToken,
               'Content-Type': 'multipart/form-data',
            }
        });
    }
    
    //Upload Business Images
    uploadBusinessDataPhoto(context, data) {
        return context.$http.post(this.baseURL + 'businesses/uploads', data, {
             headers: {
               'Origin-Host': this.apiToken,
               'Content-Type': 'multipart/form-data',
            }
        });
    }
    //..uploads


    ////--------gw-services

    

    //get single user
    getUser(context, id) {
        return context.$http.get(this.baseURL+'users/'+id, {
            headers: {
               'Origin-Host': this.apiToken
            }
        })
    }

    getUserAppSettings(context, id) {
        return context.$http.get(this.baseURL+'app/settings/users/'+id, {
            headers: {
               'Origin-Host': this.apiToken
            }
        })
    }

    //businesses local 

    getProductsInBusinessCategories(context, id) {
        return context.$http.get(this.baseURL + 'products/businesses/categories/'+id, {
            headers: {
               'Origin-Host': this.apiToken
            }
        });
    }

    //get market categories
    getMarketCategories(context) {
        return context.$http.get(this.baseURL+'market/categories', {
            headers: {
               'Origin-Host': this.apiToken
            }
        })
    }

    //get market groups
    getBusinessMarketGroups(context) {
        return context.$http.get(this.baseURL+'/app/businesses/markets/groups', {
            headers: {
               'Origin-Host': this.apiToken
            }
        })
    }

    //get site filters
    getFilters(context) {
        return context.$http.get(this.baseURL+'filters', {
            headers: {
               'Origin-Host': this.apiToken
            }
        })
    }

    //Add business
    addBusiness(context, data) {
        return context.$http.post(this.baseURL + 'businesses', data, {
             headers: {
               'Origin-Host': this.apiToken
            }
        });
    }





    

    //get business products
    getBusinessNotifications(context, id) {
        return context.$http.get(this.baseURL + 'notifications/businesses/'+id, {
            headers: {
               'Origin-Host': this.apiToken
            }
        });
    }

    //get business messages
    getBusinessMessages(context, id) {
        return context.$http.get(this.baseURL + 'messages/businesses/'+id, {
            headers: {
               'Origin-Host': this.apiToken
            }
        });
    }
    //get business orders
    getBusinessOrders(context, id) {
        return context.$http.get(this.baseURL + 'orders/businesses/'+id, {
            headers: {
               'Origin-Host': this.apiToken
            }
        });
    }
    //notifications
    getNotifications(context, id) {
        return context.$http.get(this.baseURL + 'notifications/'+id, {
            headers: {
               'Origin-Host': this.apiToken
            }
        });
    }
    //read notifications
    readNotifications(context, data) {
        return context.$http.post(this.baseURL + 'notifications/general/updates', data, {
            headers: {
              'Origin-Host': this.apiToken
           }
        });
    }
    //click notifications
    clickNotifications(context, id) {
        return context.$http.get(this.baseURL + 'notifications/clicks/'+id, {
            headers: {
              'Origin-Host': this.apiToken
           }
        });
    }
    //chats
    //get chat logs
    getChatLogs(context, id, id2) {
        return context.$http.get(this.baseURL + 'chats/logs/'+id+'/'+id2, {
            headers: {
               'Origin-Host': this.apiToken
            }
        });
    }
    //get chat log
    getChatLog(context, id, id2, id3) {
        return context.$http.get(this.baseURL + 'chats/logs/'+id+'/'+id2+'/'+id3, {
            headers: {
               'Origin-Host': this.apiToken
            }
        });
    }
    //post chat logs
    postChat(context, data) {
        return context.$http.post(this.baseURL + 'chats/posts', data, {
             headers: {
               'Origin-Host': this.apiToken
            }
        });
    }





    //categories
    //get business categories
    getProductCategories(context) {
        return context.$http.get(this.baseURL+'products/get/categories', {
            headers: {
               'Origin-Host': this.apiToken
            }
        })
    }

    getProductCategoryProducts(context, id) {
        return context.$http.get(this.baseURL + 'products/categories/products/'+id, {
            headers: {
               'Origin-Host': this.apiToken
            }
        });
    }

    //Add product category
    addProductCategory(context, data) {
        return context.$http.post(this.baseURL + 'products/add/categories', data, {
             headers: {
               'Origin-Host': this.apiToken
            }
        });
    }

    //Add category to business
    addCategory(context, data) {
        return context.$http.post(this.baseURL + 'businesses/categories', data, {
             headers: {
               'Origin-Host': this.apiToken
            }
        });
    }

    //Edit category to business
    editCategory(context, data) {
        return context.$http.put(this.baseURL + 'businesses/categories', data, {
             headers: {
               'Origin-Host': this.apiToken
            }
        });
    }
    //products calls
    //get products
    getProducts(context,offset,limit) {
        return context.$http.get(this.baseURL + 'products/all/'+offset+'/'+limit, {
            headers: {
               'Origin-Host': this.apiToken
            }
        });
    }
   
    //get market products
    getMarketProducts(context, id) {
        return context.$http.get(this.baseURL + 'products/markets/'+id, {
            headers: {
               'Origin-Host': this.apiToken
            }
        });
    }

    //get market groups products
    getMarketGroupsProducts(context, id, offset, limit) {
        return context.$http.get(this.baseURL + 'products/markets/groups/'+id+'/'+offset+'/'+limit, {
            headers: {
               'Origin-Host': this.apiToken
            }
        });
    }

    //get market activity products
    getMarketActivityProducts(context, id, offset, limit) {
        return context.$http.get(this.baseURL + 'products/markets/activities/'+id+'/'+offset+'/'+limit, {
            headers: {
               'Origin-Host': this.apiToken
            }
        });
    }

     //get business market
    getBusinessMarket(context, id) {
        return context.$http.get(this.baseURL + 'businesses/markets/'+id, {
            headers: {
               'Origin-Host': this.apiToken
            }
        });
    }

    //get businesses open to agents
    getBusinessesOpenToAgents(context,data) {
        return context.$http.post(this.baseURL + 'businesses/open/agents', data, {
            headers: {
               'Origin-Host': this.apiToken
            }
        });
    }

    //get category products
    getCategoryProducts(context, id) {
        return context.$http.get(this.baseURL + 'products/categories/'+id, {
            headers: {
               'Origin-Host': this.apiToken
            }
        });
    }

    //get category products
    getBusinessesOpenAgentsCategoryProducts(context, data) {
        return context.$http.post(this.baseURL + 'products/businesses/agents/categories', data, {
            headers: {
               'Origin-Host': this.apiToken
            }
        });
    }

    //get businesses agents products
    getBusinessesOpenAgentsProducts(context) {
        return context.$http.get(this.baseURL + 'products/agents/businesses', {
            headers: {
               'Origin-Host': this.apiToken
            }
        });
    }

    //get category products
    getAgentsBusinessCategoryProducts(context, id) {
        return context.$http.get(this.baseURL + 'products/agents/business/categories/'+id, {
            headers: {
               'Origin-Host': this.apiToken
            }
        });
    }
    
    //products by recommends
    getRecommendedProducts(context, id) {
        return context.$http.get(this.baseURL + 'products/recommends/'+id, {
            headers: {
               'Origin-Host': this.apiToken
            }
        });
    }

    //search category products
    searchCategoryProducts(context, name, type) {
        return context.$http.get(this.baseURL + 'products/search/categories/'+name+'/'+type, {
            headers: {
               'Origin-Host': this.apiToken
            }
        });
    }

    //searchproducts
    searchProducts(context, search) {
        return context.$http.get(this.baseURL + 'products/search/'+search, {
            headers: {
               'Origin-Host': this.apiToken
            }
        });
    }

    //searchbusinessproducts
    searchBusinessProducts(context, search) {
        return context.$http.get(this.baseURL + 'products/search/businesses/'+search, {
            headers: {
               'Origin-Host': this.apiToken
            }
        });
    }
    
    //get single products with name search
    getProductSearch(context, id) {
        return context.$http.get(this.baseURL+'products/product/url/'+id, {
            headers: {
               'Origin-Host': this.apiToken
            }
        })
    }

    setRelatedProducts(context, data) {
        return context.$http.post(this.baseURL + 'products/related', data, {
            headers: {
              'Origin-Host': this.apiToken
           }
        });
    }  

    //productships
    setProductAgentShip(context, data) {
        return context.$http.post(this.baseURL + 'products/ships/agents', data, {
            headers: {
              'Origin-Host': this.apiToken
           }
        });
    } 
    
    //Add products
    addProduct(context, data) {
        return context.$http.post(this.baseURL + 'products', data, {
             headers: {
               'Origin-Host': this.apiToken
              
            }
        });
    }
    addProductItem(context, data) {
        return context.$http.post(this.baseURL + 'products/items', data, {
             headers: {
               'Origin-Host': this.apiToken
            }
        });
    }

    addAgentProduct(context, data) {
        return context.$http.post(this.baseURL + 'products/agents', data, {
             headers: {
               'Origin-Host': this.apiToken
              
            }
        });
    }

    // Add product details
    addProductDetail(context, data) {
        return context.$http.post(this.baseURL + 'products/details', data, {
            headers: {
              'Origin-Host': this.apiToken
             
           }
       });
    }

    // Add product reviews
    addProductReview(context, data) {
        return context.$http.post(this.baseURL + 'products/reviews', data, {
            headers: {
              'Origin-Host': this.apiToken
             
           }
       });
    }

    //wholesaleops
    setProductITemMOQs(context, data) {
        return context.$http.post(this.baseURL + 'products/moqs', data, {
            headers: {
              'Origin-Host': this.apiToken
             
           }
       });
    }

    addToProductAddons(context, data){
        return context.$http.post(this.baseURL + 'products/addons', data, {
            headers: {
              'Origin-Host': this.apiToken
             
           }
        });
    }

    removeProductAddons(context, data){
        return context.$http.post(this.baseURL + 'products/addons/reset', data, {
            headers: {
              'Origin-Host': this.apiToken
             
           }
        });
    }

    //
    setAddProductToMoreCategories(context, data){
        return context.$http.post(this.baseURL + 'products/set/categories', data, {
            headers: {
              'Origin-Host': this.apiToken
             
           }
        });
    }

    //delete product
    deleteProduct(context, id) {
        return context.$http.delete(this.baseURL+'products/'+id, {
            headers: {
               'Origin-Host': this.apiToken
            }
        })
    }

    //edit product
    editProduct(context, id, data) {
        return context.$http.put(this.baseURL + 'products/'+id, data, {
             headers: {
               'Origin-Host': this.apiToken
            }
        });
    }

    //edit product settings
    editProductSettings(context, id, data) {
        return context.$http.put(this.baseURL + 'products/settings/'+id, data, {
             headers: {
               'Origin-Host': this.apiToken
            }
        });
    }
    
    //edit product item single
    editProductItemSingle(context, id, data) {
        return context.$http.put(this.baseURL + 'products/items/singles/'+id, data, {
             headers: {
               'Origin-Host': this.apiToken
            }
        });
    }

    //edit product item
    editProductItem(context, id, data) {
        return context.$http.put(this.baseURL + 'products/items/'+id, data, {
             headers: {
               'Origin-Host': this.apiToken
            }
        });
    }

    //restock product item
    restockProductItem(context, id, data) {
        return context.$http.put(this.baseURL + 'products/items/restock/'+id, data, {
             headers: {
               'Origin-Host': this.apiToken
            }
        });
    }


    //remove product item
    removeProductItem(context, id, data) {
        return context.$http.put(this.baseURL + 'products/items/remove/'+id, data,{
             headers: {
               'Origin-Host': this.apiToken
            }
        });
    }

    //edit product item group
    editProductItemGroup(context, id, data) {
        return context.$http.put(this.baseURL + 'products/itemgroups/'+id, data, {
             headers: {
               'Origin-Host': this.apiToken
            }
        });
    }

    //remove product item group
    removeProductItemGroup(context, id, data) {
        return context.$http.put(this.baseURL + 'products/itemgroups/remove/'+id, data,{
             headers: {
               'Origin-Host': this.apiToken
            }
        });
    }

    //remove product item
    removeProduct(context, id, data) {
        return context.$http.put(this.baseURL + 'products/remove/'+id, data,{
             headers: {
               'Origin-Host': this.apiToken
            }
        });
    }

    //edit product info
    // editProductInformation(context, data) {
    //     return context.$http.put(this.baseURL + 'products/information', data, {
    //          headers: {
    //            'Origin-Host': this.apiToken
    //         }
    //     });
    // }

    //
    editProductDetail(context, id, data) {
        return context.$http.put(this.baseURL + 'products/details/'+id, data, {
            headers: {
              'Origin-Host': this.apiToken
           }
       });
    }

    //delete product detail
    deleteProductDetail(context, id, data) {
        return context.$http.delete(this.baseURL + 'products/details/'+id, data, {
             headers: {
               'Origin-Host': this.apiToken
            }
        });
    }

    //get product delivey
    getProductDeliveryOptions(context, id) {
        return context.$http.get(this.baseURL + 'products/delivery/'+id, {
            headers: {
              'Origin-Host': this.apiToken
           }
       });
    }

    //product delivery
    setProductDelivery(context, id, data) {
        return context.$http.put(this.baseURL + 'products/delivery/'+id, data, {
            headers: {
              'Origin-Host': this.apiToken
           }
       });
    }

    setProductShippingFeeStatus(context, data) {
        return context.$http.put(this.baseURL + 'products/set/shippingfeestatus', data, {
            headers: {
              'Origin-Host': this.apiToken
           }
       });
    }

    //Set Product Delivery Options 
    setProductDeliveryOption(context, data) {
        return context.$http.post(this.baseURL + 'products/delivery/fees', data, {
             headers: {
               'Origin-Host': this.apiToken
            }
        });
    }

    //product info
    getProductInformation(context, id) {
        return context.$http.get(this.baseURL + 'products/information/'+id, {
            headers: {
              'Origin-Host': this.apiToken
           }
       });
    }

    //add product info
    addProductInformation(context, data) {
        return context.$http.post(this.baseURL + 'products/information', data, {
            headers: {
              'Origin-Host': this.apiToken
             
           }
       });
   }
    //
    editProductInformation(context, id, data) {
        return context.$http.put(this.baseURL + 'products/information/'+id, data, {
            headers: {
              'Origin-Host': this.apiToken
           }
       });
    }

    //delete product detail
    deleteProductInformation(context, id, data) {
        return context.$http.delete(this.baseURL + 'products/information/'+id, data, {
             headers: {
               'Origin-Host': this.apiToken
            }
        });
    }
    //./product info

    //gallery info
    //edit gallery
    editGallery(context, id, data) {
        return context.$http.put(this.baseURL + 'posts/gallery/'+id, data, {
             headers: {
               'Origin-Host': this.apiToken
            }
        });
    }

    //delete gallery
    deleteGallery(context, id) {
        return context.$http.delete(this.baseURL + 'posts/gallery/'+id, {
             headers: {
               'Origin-Host': this.apiToken
            }
        });
    }

    //edit gallery post
    editGalleryPost(context, id, data) {
        return context.$http.put(this.baseURL + 'posts/gallery/posts/'+id, data, {
             headers: {
               'Origin-Host': this.apiToken
            }
        });
    }


    //delete gallery post
    deleteGalleryPost(context, id) {
        return context.$http.delete(this.baseURL + 'posts/gallery/posts/'+id, {
             headers: {
               'Origin-Host': this.apiToken
            }
        });
    }
    //./posts
    //./gallery info
    
    //reset
    resetData(context, type, id) {
        return context.$http.get(this.baseURL+'data/reset/'+type+'/'+id, {
            headers: {
               'Origin-Host': this.apiToken
            }
        })
    }

    deleteImages(context, id, data) {
        return context.$http.put(this.baseURL+'data/images/'+id, data, {
            headers: {
               'Origin-Host': this.apiToken
            }
        })
    }
    
    //checkout
    checkout(context, data) {
        return context.$http.post(this.baseURL + 'orders', data, {
             headers: {
               'Origin-Host': this.apiToken,
            }
        });
    }

    //spinoff
    makeOrderSpinoff(context, data) {
        return context.$http.post(this.baseURL + 'orders/spinoffs', data, {
             headers: {
               'Origin-Host': this.apiToken,
            }
        });
    }

    //map post order
    makeCustomOrder(context, data) {
        return context.$http.post(this.baseURL + 'map/orders', data, {
             headers: {
               'Origin-Host': this.apiToken,
            }
        });
    }

    makeDirectPayment(context, data) {
        return context.$http.post(this.baseURL + 'payments/make/direct', data, {
             headers: {
               'Origin-Host': this.apiToken,
            }
        });
    }

    //get order additionals
    getOrderAdditionals(context, data){
        return context.$http.post(this.baseURL + 'orders/additionals/get', data, {
            headers: {
              'Origin-Host': this.apiToken,
           }
        });
    }

    //get order chart
    getOrderChart(context, data){
        return context.$http.post(this.baseURL + 'orders/charts', data, {
            headers: {
              'Origin-Host': this.apiToken,
           }
        });
    }
    
    //checkout orders
    getMapOrderChart(context, id) {
        return context.$http.get(this.baseURL + 'map/app/orders/chart/'+id, {
            headers: {
               'Origin-Host': this.apiToken,
            }
        });
    }

    //checkout orders
    getCheckoutOrder(context, url) {
        return context.$http.get(this.baseURL + 'orders/url/'+url, {
             headers: {
               'Origin-Host': this.apiToken,
            }
        });
    }

    //remake ordercheckout 
    getCheckoutOrderReMake(context, ref) {
        return context.$http.get(this.baseURL + 'orders/remakes/'+ref, {
             headers: {
               'Origin-Host': this.apiToken,
            }
        });
    }
    //checkout orders
    getCheckoutOrders(context, id) {
        return context.$http.get(this.baseURL + 'orders/topays/'+id, {
             headers: {
               'Origin-Host': this.apiToken,
            }
        });
    }

    //checkout orders for gift-card checkout
    getCheckoutGiftCardOrders(context, data) {
        return context.$http.post(this.baseURL + 'orders/use/giftcards/requests', data, {
             headers: {
               'Origin-Host': this.apiToken,
            }
        });
    }

    generatePaymentOrder(context, data) {
        return context.$http.post(this.baseURL + 'orders/paymentorders', data, {
             headers: {
               'Origin-Host': this.apiToken,
            }
        });
    }

    acceptPaymentOrder(context, data) {
        return context.$http.post(this.baseURL + 'orders/accept/paymentorders', data, {
             headers: {
               'Origin-Host': this.apiToken,
            }
        });
    }

    getPaymentOrders(context, data) {
        return context.$http.post(this.baseURL + 'orders/get/paymentorders', data, {
             headers: {
               'Origin-Host': this.apiToken,
            }
        });
    }

    //user delivery details
    getUserDeliveryDetails(context, id) {
        return context.$http.get(this.baseURL + 'users/deliverydetails/'+id, {
             headers: {
               'Origin-Host': this.apiToken,
            }
        });
    }

    //preps
    preparePayments(context, data) {
        return context.$http.post(this.baseURL + 'payments/preparepayments', data, {
             headers: {
               'Origin-Host': this.apiToken,
            }
        });
    }

    //verify
    verifyRavePayment(context, data) {
        return context.$http.post(this.baseURL + 'data/ext/calls', data, {
             headers: {
               'Origin-Host': this.apiToken,
            }
        });
    }

    //update
    updatePayment(context, data) {
        return context.$http.post(this.baseURL + 'payments', data, {
             headers: {
               'Origin-Host': this.apiToken,
            }
        });
    }

    updatePaymentService(context, data) {
        return context.$http.post(this.baseURL + 'payments/service', data, {
             headers: {
               'Origin-Host': this.apiToken,
            }
        });
    }

    updateOrderBasics(context, data) {
        return context.$http.post(this.baseURL + 'orders/updates/basics', data, {
             headers: {
               'Origin-Host': this.apiToken,
            }
        });
    }

    updateOrders(context, data) {
        return context.$http.post(this.baseURL + 'orders/updates', data, {
             headers: {
               'Origin-Host': this.apiToken,
            }
        });
    }

    createOrder(context, data) {
        return context.$http.post(this.baseURL + 'map/orders/create', data, {
             headers: {
               'Origin-Host': this.apiToken,
            }
        });
    }
    
    updatePaymentDetails(context, data) {
        return context.$http.post(this.baseURL + 'payments/updates', data, {
             headers: {
               'Origin-Host': this.apiToken,
            }
        });
    }

    //get orders
    getOrders(context, id) {
        return context.$http.get(this.baseURL + 'orders/'+id, {
             headers: {
               'Origin-Host': this.apiToken,
            }
        });
    }

    //get orders by ref bash
    getOrdersByRefBash(context, id) {
        return context.$http.get(this.baseURL + 'orders/ref/'+id, {
             headers: {
               'Origin-Host': this.apiToken,
            }
        });
    }

    //get app business orders
    getAppBusinessOrders(context, id) {
        return context.$http.get(this.baseURL + 'app/orders/businesses/'+id, {
             headers: {
               'Origin-Host': this.apiToken,
            }
        });
    }

    //OrdersPendingPayments
    getAppBusinessOrdersPendingPayments(context, id, id2) {
        return context.$http.get(this.baseURL + 'app/payments/pending/'+id+'/'+id2, {
             headers: {
               'Origin-Host': this.apiToken,
            }
        });
    }

    //get order details
    getOrderDetails(context, data) {
        return context.$http.post(this.baseURL + 'orders/details', data, {
             headers: {
               'Origin-Host': this.apiToken,
            }
        });
    }

    //transactions
    //get app business transactions
    getAppBusinessTransactions(context, id) {
        return context.$http.get(this.baseURL + 'app/transactions/businesses/'+id, {
             headers: {
               'Origin-Host': this.apiToken,
            }
        });
    }

    //customers
    //get app business customers
    getAppBusinessCustomers(context, id) {
        return context.$http.get(this.baseURL + 'app/customers/businesses/'+id, {
             headers: {
               'Origin-Host': this.apiToken,
            }
        });
    }

    //services
    //Add service to business
    addService(context, data) {
        return context.$http.post(this.baseURL + 'businesses/services', data, {
             headers: {
               'Origin-Host': this.apiToken
            }
        });
    }

    //Edit services to business
    editService(context, data) {
        return context.$http.put(this.baseURL + 'businesses/services', data, {
             headers: {
               'Origin-Host': this.apiToken
            }
        });
    }

    //product info
    getBusinessDeliveryOptions(context, id) {
        return context.$http.get(this.baseURL + 'businesses/deliveryoptions/'+id, {
            headers: {
              'Origin-Host': this.apiToken
           }
       });
    }

    //product info
    checkBusinessPayOnDelivery(context, id) {
        return context.$http.get(this.baseURL + 'businesses/checkdeliveryoptions/'+id, {
            headers: {
              'Origin-Host': this.apiToken
           }
       });
    }

    //business contact form
    sendBusinessContactForm(context, data) {
        return context.$http.post(this.baseURL + 'businesses/contacts', data, {
            headers: {
               'Origin-Host': this.apiToken
            }
        });
    }
    //business filter options
    setBusinessFilterOptions(context, data) {
        return context.$http.put(this.baseURL + 'businesses/filters', data, {
             headers: {
               'Origin-Host': this.apiToken
            }
        });
    }
    removeBusinessFilterOption(context, data) {
        return context.$http.post(this.baseURL + 'businesses/filters', data, {
             headers: {
               'Origin-Host': this.apiToken
            }
        });
    }
    //business bank details
    setBusinessBankDetails(context, data) {
        return context.$http.put(this.baseURL + 'businesses/bankdetails', data, {
             headers: {
               'Origin-Host': this.apiToken
            }
        });
    }

    //business get banks from ravepay
    getRavepayBanksCHECK_XX(context) {
        return context.$http.get(this.proxyURL + this.ravepay_test_path + 'v2/banks/NG/?public_key=FLWPUBK-8b636e40e721ae65285c678950808ef5-X', {
            headers: {
                'Content-Type': 'application/json' 
            }
        });
    }

    getRavepayBanks(context){
        return context.$http.get(this.ravepay_call_path +'v2/banks/NG/?public_key='+this.ravepay_public_key, {
            headers: {'Content-Type': 'application/json' } 
        })
    }

    getRavepayBanksXX(){
        return axios.get(this.ravepay_call_path +'v2/banks/NG/?public_key='+this.ravepay_public_key, {
            headers: {'Content-Type': 'application/json' } 
        })
    }

    //
    createRavepaySubaccount(data){
        return axios.post(this.ravepay_call_path +'v2/gpx/subaccounts/create', data, { 
            headers: {'Content-Type': 'application/json' } 
        })
    }

    //ravepay transfer payouts
    transferPayoutRavepay(data) {
        return axios.post(this.ravepay_call_path +'v3/transfers', data, { 
            headers: {
                'Content-Type': 'application/json',
                Authorization: 'Bearer '+this.ravepay_secret_test
            } 
        })
    }

    //postgeneral orders
    postBusinessGeneralOrders(context, data) {
        return context.$http.post(this.baseURL + 'orders/generalorders', data, {
             headers: {
               'Origin-Host': this.apiToken
            }
        });
    }

    //rewards
    //get reward types
    getGeneralRewardTypes(context, id) {
        return context.$http.get(this.baseURL + 'rewards/types', {
            headers: {
              'Origin-Host': this.apiToken
           }
       });
    }
    //get business rewards
    getBusinessRewardSettings(context, id) {
        return context.$http.get(this.baseURL + 'businesses/rewards/settings/'+id, {
             headers: {
               'Origin-Host': this.apiToken,
            }
        });
    }
    //business set reward 
    postBusinessRewardSettings(context, data) {
        return context.$http.post(this.baseURL + 'businesses/rewards/settings', data, {
             headers: {
               'Origin-Host': this.apiToken
            }
        });
    }
    
    updateBusinessRewardSettings(context, data) {
        return context.$http.put(this.baseURL + 'businesses/rewards/settings', data, {
             headers: {
               'Origin-Host': this.apiToken
            }
        });
    }

    updateBusinessGeneralSettings(context, data) {
        return context.$http.put(this.baseURL + 'businesses/updates', data, {
             headers: {
               'Origin-Host': this.apiToken
            }
        });
    }

    //collections
    
    //get collections
    getUserCollections(context, id) {
        return context.$http.get(this.baseURL + 'collections/users/'+id, {
            headers: {
              'Origin-Host': this.apiToken
           }
       });
    }

    //get monies
    getUserMonies(context, id) {
        return context.$http.get(this.baseURL + 'monies/users/'+id, {
            headers: {
              'Origin-Host': this.apiToken
           }
       });
    }

    //post collection services
    postCollectionsServices(context, data) {
        return context.$http.post(this.baseURL + 'collections/services', data, {
             headers: {
               'Origin-Host': this.apiToken
            }
        });
    }

    //agentsco
    getActiveBrokers(context){
        return context.$http.get(this.baseURL + 'agentsco/brokers', {
            headers: {
              'Origin-Host': this.apiToken
           }
       });
    }
    postAgentRequests(context, data) {
        return context.$http.post(this.baseURL + 'agentsco/requests', data, {
             headers: {
               'Origin-Host': this.apiToken
            }
        });
    }

    acceptBrokerRequests(context, data) {
        return context.$http.post(this.baseURL + 'agentsco/requests/brokers/accept', data, {
             headers: {
               'Origin-Host': this.apiToken
            }
        });
    }

    setBrokerRequestFee(context, data) {
        return context.$http.post(this.baseURL + 'agentsco/requests/brokers/fee', data, {
             headers: {
               'Origin-Host': this.apiToken
            }
        });
    }

    getBrokerData(context, id) {
        return context.$http.get(this.baseURL + 'agentsco/brokers/data/'+id, {
            headers: {
              'Origin-Host': this.apiToken
           }
       });
    }
    
    //referal
    setReferralBash(context, data) {
        return context.$http.post(this.baseURL + 'agentsco/requests/refs', data, {
            headers: {
              'Origin-Host': this.apiToken
           }
        });
    }

    getReferralBashDetails(context, id) {
        return context.$http.get(this.baseURL + 'agentsco/requests/data/'+id, {
            headers: {
              'Origin-Host': this.apiToken
           }
       });
    }

    //activities
    regActivity(context, data) {
        return context.$http.post(this.baseURL + 'activities/registers', data, {
            headers: {
              'Origin-Host': this.apiToken
           }
        });
    }

    setActivity(context, data) {
        return context.$http.post(this.baseURL + 'activities/requests/sets', data, {
            headers: {
              'Origin-Host': this.apiToken
           }
        });
    }

    getActivities(context, data) {
        return context.$http.post(this.baseURL + 'activities/requests', data, {
            headers: {
              'Origin-Host': this.apiToken
           }
        });
    }

    updateActivity(context, data) {
        return context.$http.post(this.baseURL + 'activities/requests/updates', data, {
            headers: {
              'Origin-Host': this.apiToken
           }
        });
    }

    //messages
    //post message
    postMessages(context, data) {
        return context.$http.post(this.baseURL + 'messages', data, {
             headers: {
               'Origin-Host': this.apiToken
            }
        });
    }

    //post message thread
    postMessageThreads(context, data) {
        return context.$http.post(this.baseURL + 'messages/threads', data, {
             headers: {
               'Origin-Host': this.apiToken
            }
        });
    }
    //get user messages
    getUserMessages(context, id) {
        return context.$http.get(this.baseURL + 'messages/users/'+id, {
            headers: {
                'Origin-Host': this.apiToken
            }
        });
    }


}


// WEBPACK FOOTER //
// ./src/services/service.js